<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="classId"
            search-url="/schoolLessonPlan/listAll"
            create-url=""
            delete-url=""
            form-type="intable"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :acceptView="false"
            :accept-edit="false"
            :acceptCreate2=false
            :accept-create=false
            @viewPdf="viewPdf"
            @downloadPdf="downloadPdf"
            :acceptExport="0"
            @viewItem=""
        >
        </c-search-form>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import SchoolCreateForm from "@/views/admin/school_lesson_plan/SchoolLessonPlanCreate";

export default {
  name: "school-class",
  components: {SchoolCreateForm, CSearchForm},
  data: () => {
    return {
      formName: "Danh sách Giáo án Edu Smart",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      allAcount: 0,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center",
        },
        {
          value: 'lessonName',
          text: 'Lesson',
          search: true,
          sortable:false,
          width: "15%",
          headerStyle: "text-align:center; wrap:true",
        },

        {
          value: 'unitName',
          text: 'Unit',
          search: true,
          sortable:false,
          width: "15%",
          headerStyle: "text-align:center; wrap:true",
        },
        {
          value: 'levelName',
          text: 'Level',
          search: true,
          sortable:false,
          width: "5%",
          headerStyle: "text-align:center; wrap:true",
        },

        {
          value: 'custom_action_list',
          width: "5%",
          text: 'Xem Pdf',
          headerStyle: "text-align:center;",
          items: [
            {
              icon: "visibility",
              event: "viewPdf",
              color: "primary"
            },
          ],
        },
        {
          value: 'custom_action_list',
          width: "5%",
          text: 'Tải Pdf',
          headerStyle: "text-align:center;",
          items: [
            {
              icon: "cloud_download",
              event: "downloadPdf",
              color: "primary"
            },
          ],
        },
      ],
    };
  },

  created() {
  },

  methods: {
    viewPdf(item) {
      window.open(item.urlEduSmart, "_blank");
    },
    async downloadPdf(item) {
      try {
        const response = await fetch(item.urlEduSmart, { mode: "cors" });
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = item.lessonName || "document.pdf";
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } catch (error) {
        console.error("Download failed:", error);
        alert("Failed to download. The site may have restrictions.");
      }
    },
    clearFromDate() {
      this.hiddenFields.fromDate = null;
    },
    clearToDate() {
      this.hiddenFields.toDate = null;
    },
    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới ';
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật';
      }
      this.visibleCreateDialog = true;
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },


    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
  },

  destroyed() {
  },
};
</script>
